import AlertIcon from '../../../../../components/Icons/AlertIcon';
import CheckCircleIcon from '../../../../../components/Icons/CheckCircle';
import CreditCard01Icon from '../../../../../components/Icons/credit-card-01';
import Send01Icon from '../../../../../components/Icons/send-01';
import { colors } from '../../../../../components/ThemeProvider/themeColors';

export const getStatusConfig = (
  t: (key: string, options?: Record<string, unknown>) => string
): Record<string, { label: string; color: string; icon: React.ReactNode; backgroundColor: string }> => ({
  SMS_SENT: {
    label: t('statuses.smsSent'),
    color: colors.base[700],
    icon: <Send01Icon sx={{ width: '16px', height: '16px', color: colors.error[600] }} />,
    backgroundColor: colors.base[50],
  },
  SMS_ERROR: {
    label: t('statuses.smsError'),
    color: colors.error[600],
    icon: <AlertIcon sx={{ width: '16px', height: '16px', color: colors.error[600] }} />,
    backgroundColor: colors.error[50],
  },
  CARD_READY: {
    label: t('statuses.cardReady'),
    color: colors.success[600],
    icon: <CheckCircleIcon color='secondary' sx={{ width: '16px', height: '16px' }} />,
    backgroundColor: colors.success[50],
  },
  CARD_ORDERED: {
    label: t('statuses.cardOrdered'),
    color: colors.info[600],
    icon: <CreditCard01Icon sx={{ width: '16px', height: '16px', color: colors.info[600] }} />,
    backgroundColor: colors.info[50],
  },
  SIMA_PENDING: {
    label: t('statuses.simaPending'),
    color: colors.warning[600],
    icon: <AlertIcon sx={{ width: '16px', height: '16px', color: colors.warning[600] }} />,
    backgroundColor: colors.warning[50],
  },
});
